import Vue from "vue";
import axios from "axios";

axios.defaults.headers["Content-Type"] = "application/json";
const token = localStorage.getItem("token");

Vue.use({
  install(Vue) {
    Vue.prototype.$http = axios.create({
      // baseURL: "http://localhost:3000/",
      baseURL: "https://api.gestaodefrota.net.br/",
      headers: { Authorization: `Bearer ${token}` },
    });
  },
});
